import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axiosInstance";
import { CausalLoopRctState, JobConfig, JobRun } from "../models/interfaces";
import { JobType } from "../constants/JobTypes";

// Mirrors causalLoopSlice.ts exactly, scoped to JobType.CausalLoopRct.
const initialState: CausalLoopRctState = {
  jobConfigList: [],
  jobRunList: [],
  loading: false,
};

export const fetchJobConfigCausalLoopRct = createAsyncThunk<JobConfig[]>(
  "causalLoopRct/fetchJobConfig",
  async () => {
    const response = await axiosInstance.get(
      `/api/jobConfig/jobType/${JobType.CausalLoopRct}`
    );
    return response.data.items;
  }
);

export const fetchJobRunCausalLoopRct = createAsyncThunk<JobRun[]>(
  "causalLoopRct/fetchJobRun",
  async () => {
    const response = await axiosInstance.get(
      `/api/jobRun/jobType/${JobType.CausalLoopRct}`
    );
    return response.data.items;
  }
);

const causalLoopRctSlice = createSlice({
  name: "causalLoopRct",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobConfigCausalLoopRct.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchJobConfigCausalLoopRct.fulfilled,
        (state, action: PayloadAction<JobConfig[]>) => {
          state.jobConfigList = action.payload;
          state.loading = false;
        }
      )
      .addCase(fetchJobConfigCausalLoopRct.rejected, (state) => {
        state.loading = false;
      })
      .addCase(
        fetchJobRunCausalLoopRct.fulfilled,
        (state, action: PayloadAction<JobRun[]>) => {
          state.jobRunList = action.payload;
        }
      );
  },
});

export default causalLoopRctSlice.reducer;
